module.exports = __webpack_public_path__ + "img/34.5844b58d.png";